import { root } from './type';

export const type = {
  ...root,
};
